/*
 * File: CustomeTheme.js
 * Project: patient-portal
 *
 * Created by Nate Weber on 08/10/2020
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: This is the custom theme provider that allows us to
 * customize the theme.
 */

import React from "react";
import PropTypes from "prop-types";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#418CCA"
    }
  }
});

const CustomTheme = ({ children }) => {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

CustomTheme.propTypes = {
  children: PropTypes.node.isRequired
};

export default CustomTheme;
